import { useMutation } from '@tanstack/react-query';

import { useResetUserInfo, useUserInfo } from '@/features/users';

import { deleteImage } from '../api';

import { useResetUserQueries } from './use-reset-user-queries';

export const useDeleteImage = (uuid: string) => {
  const resetUserQueries = useResetUserQueries();
  const resetUserInfo = useResetUserInfo();
  const user = useUserInfo();

  return useMutation({
    mutationFn: deleteImage,
    onSuccess: async () => {
      if (uuid === user.user_id) {
        await resetUserInfo();
      }

      resetUserQueries();
    },
    onError: () => {},
  });
};
